/**
 * form_start / form_submit / form_error collector'i.
 * Form terk analizi icin ilk alan focus'u form_start olarak gonderilir.
 * Alan degerleri hicbir kosulda toplanmaz; yalnizca alan adlari (hassas olanlar maskeli).
 */
import { AUTO_EVENTS } from "../events";
import { describeForm, fieldName } from "./dom";

class FormsCollector {
    constructor(tracker) {
        this.tracker = tracker;
        this.startedForms = [];
    }

    start() {
        const self = this;
        document.addEventListener(
            "focusin",
            function (event) {
                try {
                    self.onFocus(event);
                } catch (e) {
                    /* yoksay */
                }
            },
            true
        );
        document.addEventListener(
            "submit",
            function (event) {
                try {
                    self.onSubmit(event);
                } catch (e) {
                    /* yoksay */
                }
            },
            true
        );
        document.addEventListener(
            "invalid",
            function (event) {
                try {
                    self.onInvalid(event);
                } catch (e) {
                    /* yoksay */
                }
            },
            true
        );
    }

    formKey(form) {
        return (form.id || "") + "|" + (form.name || "") + "|" + (form.action || "");
    }

    onFocus(event) {
        const field = event.target;
        if (!field || !field.form) return;
        const tag = (field.tagName || "").toLowerCase();
        if (tag !== "input" && tag !== "textarea" && tag !== "select") return;

        const key = this.formKey(field.form);
        if (this.startedForms.indexOf(key) !== -1) return;
        this.startedForms.push(key);

        const info = describeForm(field.form);
        this.tracker.emit(
            AUTO_EVENTS.FORM_START,
            {
                form_id: info.id,
                form_name: info.name,
                first_field: fieldName(field),
            },
            { form: { id: info.id, name: info.name, field: fieldName(field) } }
        );
    }

    onSubmit(event) {
        const form = event.target;
        if (!form || (form.tagName || "").toLowerCase() !== "form") return;
        const info = describeForm(form);
        const fieldCount = form.elements ? form.elements.length : 0;
        this.tracker.emit(
            AUTO_EVENTS.FORM_SUBMIT,
            {
                form_id: info.id,
                form_name: info.name,
                action: info.action,
                field_count: fieldCount,
            },
            { form: { id: info.id, name: info.name, field: "" } }
        );
        // Submit genelde navigasyon tetikler
        this.tracker.flush("form_submit");
    }

    onInvalid(event) {
        const field = event.target;
        if (!field || !field.form) return;
        const info = describeForm(field.form);
        const validation = field.validationMessage ? String(field.validationMessage).slice(0, 120) : "";
        this.tracker.emit(
            AUTO_EVENTS.FORM_ERROR,
            {
                form_id: info.id,
                form_name: info.name,
                field: fieldName(field),
                message: validation,
            },
            { form: { id: info.id, name: info.name, field: fieldName(field) } }
        );
    }
}

export default FormsCollector;



//////////////////
// WEBPACK FOOTER
// ./static/src/tracker/collectors/forms.js
// module id = null
// module chunks = 